import { render, staticRenderFns } from "./AdminBaseView.vue?vue&type=template&id=6439f8c2&"
import script from "./AdminBaseView.vue?vue&type=script&lang=js&"
export * from "./AdminBaseView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports